import {
    isMoneyMapIncomeSplitEligible,
    MoneyMapVisual,
} from '@fruitful/money-map';
import type {
    MoneyMapAccountWithAccountDetails,
    MoneyMapWithRulesAndAccounts,
} from '@fruitful/types';
import { XStack, YStack } from 'smoothie';

import {
    PreviewSection,
    PreviewSectionIconMap,
} from '../../types/PreviewSection';
import { PreviewContainer } from './PreviewContainer';
import PreviewSectionHeader from './PreviewSectionHeader';

interface PreviewVisualProps {
    moneyMap: MoneyMapWithRulesAndAccounts;
    accounts: MoneyMapAccountWithAccountDetails[];
    billsTotalCents: number | null;
    spendTotalCents: number | null;
    goalsTotalCents: number | null;
}

export const PreviewVisual = ({
    moneyMap,
    accounts,
    billsTotalCents,
    spendTotalCents,
    goalsTotalCents,
}: PreviewVisualProps) => {
    const isIncomeSplitEligible = isMoneyMapIncomeSplitEligible(
        moneyMap,
        accounts,
    );

    return (
        <PreviewContainer>
            <YStack gap={8}>
                <PreviewSectionHeader
                    icon={PreviewSectionIconMap[PreviewSection.MONEY_MAP]}
                    title={PreviewSection.MONEY_MAP}
                />
                <XStack>
                    <MoneyMapVisual
                        incomeTotalCents={moneyMap.monthlyIncomeCents}
                        billsTotalCents={billsTotalCents}
                        spendTotalCents={spendTotalCents}
                        goalsTotalCents={goalsTotalCents}
                        isIncomeSplitEligible={isIncomeSplitEligible}
                    />
                </XStack>
            </YStack>
        </PreviewContainer>
    );
};
